import React, { useContext, useState, useEffect,useRef } from 'react'
import {dataContext,localestr} from '../utils.js'
import icon from '../icons.svg' 
import TreeView from './TreeView'


//function EditFld({Capt,Value,typeVal,setVal,width1,width2,disabled=false}){
function EditFld({title,Value,typeVal,setVal,disabled=false,style=undefined,id=undefined}){
        let data=[]
    const context=useContext(dataContext)
    data=context.data[typeVal]
    if (typeof data === 'undefined') data=[]

    const node = useRef(null);
    const [showDlg, setShow] = useState(false);
    const addTWnd=context.addTWnd

    const new_folder=()=>{
        addTWnd('Вибір',typeVal+'_edit',(el)=>{setVal(el);setShow(false)},null,null,true)
    }

    useEffect(() => {
        if (typeVal.substring(0, 3)==='fld'){
            if (context.data[typeVal] === undefined) {
                context.getData('cat'+typeVal.substring(3))
            } 
        }
    },)

    useEffect(()=>{
        const listener = (event) =>{
            if(event.target.id==='fld_div') setShow(false)
            if (node.current && event.target && node.current.contains(event.target)) return
            setShow(false)
            } 
        if (showDlg) document.addEventListener("mousedown", listener)
        return () => {document.removeEventListener("mousedown", listener)}
    })
    
    const cap=typeVal==='fldGoods'?localestr('Товари'):typeVal==='fldMenuGrp'?localestr('Категорії меню'):typeVal==='fldDiscounts'?localestr('Клієнти/Знижки'):localestr('Контрагенти')
    const elId='id'+Math.random()
    let val=(Value||{name:''}).name||''

    if (showDlg) {
        return(
        <div id='fld_div' ref={node} style={{...style,display:'inline-flex',position:'relative',margin:'1px 0',height:'24px'}} onKeyUp={e=>{if(e.key==='F4') setShow(false)}}>
            <input title={title} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={val} id={elId} readOnly disabled={disabled} />

            <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer'}} src={icon+'#fld'} alt='' onClick={()=>{setShow(false)}}/>
            <div className='no-print modal-fld'>
                <TreeView TreeData={data} Caption={cap} currFolder={Value} hClick={(el)=>{setVal(el);setShow(false)}} hDragDrop={()=>{}}/>
                <div style={{fontWeight:'bold',cursor:'pointer',paddingLeft:'16px'}} onClick={new_folder}>+ {localestr('Нова папка')}</div>
            </div>
        </div>
        )
    }
    else return(
        <div id='fld_div' ref={node} style={{...style,display:'inline-flex',position:'relative',margin:'1px 0',height:'24px'}} onKeyUp={e=>{if(e.key==='F4') setShow(true)}}>
            <input title={title} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={val} id={elId} readOnly disabled={disabled} />
            <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#fld'} alt='' onClick={()=>{if(!disabled) setShow(disabled?false:true)}}/>
        </div>
    )
}

export default EditFld